<template>
    <v-container container--fluid>
        <v-layout row wrap align-center justify-space-around class="pa-2 mx-auto">
            <v-flex xs12 class="text-left">
                <h1 class="grey--text lighten-3 mb-2">Teams</h1>
                <v-card class="elevation-12">
                    <v-card-title>
                        Teams List
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" clearable single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :search="search" :loading="teamsLoading" :sort-by="['o_date']" :sort-desc="[true]" must-sort :items-per-page="10" :headers="headers" :items="teams" item-key="t_id" class="elevation-1">
                        <template slot="item" slot-scope="props">
                            <tr>
                                <!-- <td>#{{ props.item.t_id }}</td> -->
                                <td class="text-left mob_small_btn"><v-btn small color="primary" :to="{name: 'teamDetail', params: {team_id: props.item.t_id}}"><span class="hide_mob_icon">View</span><v-icon right medium>visibility</v-icon></v-btn><v-btn small v-if="!props.item.t_season_archived && props.item.t_season_status && props.item.t_division_status" class="ml-2" color="secondary" :to="{name: 'draw', params: {season_id: props.item.t_season_id, division_id: props.item.t_division_id, team_name: props.item.t_name}}"><span class="hide_mob_icon">Draw</span><v-icon right medium>event</v-icon></v-btn> {{ props.item.t_name | capitalize }}</td>
                                <td class="text-left">{{ props.item.t_division | capitalize }}</td>
                                <td class="text-left">{{ props.item.t_season | capitalize }}</td>
                                <td class="text-left">{{ props.item.t_function | capitalize }}</td>
                                <!-- <td class="justify-end align-center layout">
                                    <v-btn color="primary" :to="{name: 'teamDetail', params: {team_id: props.item.t_id}}">View <v-icon right medium>visibility</v-icon></v-btn>
                                </td> -->
                            </tr>
                        </template>
                        <template slot="no-data">
                            <div class="justify-center align-center layout">
                                <v-icon left medium>warning</v-icon>Sorry, No Teams Yet
                            </div>
                        </template>
                        <template slot="no-results">
                            <div class="justify-center align-center layout">
                                <v-icon left medium>warning</v-icon>Sorry, No Results found for "{{ search }}"
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from './_store';

export default {
    name: 'TeamModule',
    components: {
        //
    },
    data () {
        return {
            search: '',
            headers: [
                // { text: '', sortable: false},
                { text: 'Team', value: 't_name' },
                { text: 'Division', value: 't_division' },
                { text: 'Season', value: 't_season' },
                { text: 'Position', value: 't_function' },
                // { text: 'Actions', align: 'right', sortable: false }
            ],
        }
    },
    computed: {
        teamsLoading(){
            return this.$store.getters['team/teamStatus'] == 'loading';
        },
        teams(){
            return this.$store.getters['team/teams'];
        },
    },
    methods: {

    },
    beforeCreate(){
        // this.$store.dispatch('user/userRequest');
        // if(_.isEmpty(this.$store.getters['team/teams'])){
            this.$store.dispatch('team/teamRequest');
        // }
    }
};
</script>

<style scoped>
@media only screen and (max-width: 768px) {
    .mob_small_btn .v-btn {min-width: 44px !important; padding: 0 8px !important;}
    .mob_small_btn .v-btn i {margin: 0 !important;}
    .hide_mob_icon {display: none !important;}
}
</style>
